module.exports = __webpack_public_path__ + "img/overview9.87d4984f.png";